import { Component, OnInit, inject, viewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { QuillEditorComponent, QuillModule } from 'ngx-quill'

import Quill from 'quill/core';
import { Mention, MentionBlot } from "quill-mention";
import { CampaignDescriptionUtils } from 'src/app/common/utils/CampaignDescriptionUtils';
import { ButtonComponent } from "wecheer-common";

Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });
export default Quill;

@Component({
  selector: 'campaign-description-link',
  templateUrl: './campaign-description-link.component.html',
  styleUrls: ['./campaign-description-link.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FlexLayoutModule,
    QuillModule,
    ButtonComponent
  ]
})
export class CampaignDescriptionLinkComponent implements OnInit {
  data = inject<{
    title: string;
  }>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<CampaignDescriptionLinkComponent>>(MatDialogRef);

  readonly editor = viewChild(QuillEditorComponent);

  public modules = {
    toolbar: [],
    mention: CampaignDescriptionUtils.getMention()
  };

  constructor() {
    const data = this.data;

    this.linkForm.patchValue({
      title: data.title
    })
  }

  ngOnInit() {
    CampaignDescriptionUtils.clearSelectionItems();
  }

  public linkForm = new FormGroup({
    title: new FormControl('', Validators.required),
    value: new FormControl(''),
  });

  onSubmit() {
    const f: any = this.linkForm.value;
    f.value = this.editor()['elementRef'].nativeElement.innerText;
    this.dialogRef.close({ title: f.title, value: f.value });
  }

}
